export const styles = {
  // 🌑 Fundo total da página (Onde fica tudo por trás)
  container: { 
    display: 'flex', 
    width: '100vw', 
    height: '100vh', 
    backgroundColor: '#000', // Preto Puro
    fontFamily: 'Inter, sans-serif' 
  },

  // 🚪 Barra lateral de navegação
  sidebar: { 
    width: 260, 
    backgroundColor: '#0a0a0a', // Cinza quase preto
    borderRight: '1px solid #222', // Linha divisória sutil
    padding: 25, 
    display: 'flex', 
    flexDirection: 'column' as any 
  },

  // 🎬 Texto da Logo (PlayFeed)
  logo: { 
    fontSize: 22, 
    fontWeight: 'bold' as any, 
    marginBottom: 40, 
    color: '#ff0000', // Vermelho oficial
    letterSpacing: '1px' 
  },

  nav: { display: 'flex', flexDirection: 'column' as any, gap: 10 },

  // ⚪ Botões apagados do menu
  navBtn: { 
    display: 'flex', 
    alignItems: 'center', 
    gap: 12, 
    padding: '12px 15px', 
    backgroundColor: 'transparent', 
    border: 'none', 
    color: '#888', // Letra cinza (inativo)
    cursor: 'pointer', 
    borderRadius: 10, 
    textAlign: 'left' as any, 
    fontSize: 15 
  },

  // 🔴 Botão ativo do menu
  navBtnActive: { 
    display: 'flex', 
    alignItems: 'center', 
    gap: 12, 
    padding: '12px 15px', 
    backgroundColor: '#1a1a1a', // Fundo um pouco mais claro para destacar
    border: 'none', 
    color: '#fff', 
    borderRadius: 10, 
    textAlign: 'left' as any, 
    fontSize: 15, 
    fontWeight: 'bold' as any 
  },

  // 📺 Área principal onde fica o formulário
  main: { 
    flex: 1, 
    padding: '60px 80px', 
    backgroundColor: '#050505', // Um pouco acima do preto puro para dar contraste
    overflowY: 'auto' as any 
  },

  header: { marginBottom: 40 },

  // 📝 O "Card" onde você digita as informações do vídeo
  formCard: { 
    backgroundColor: '#0a0a0a', 
    padding: 40, 
    borderRadius: 24, 
    border: '1px solid #222', // Borda para o card não sumir no fundo preto
    display: 'flex', 
    flexDirection: 'column' as any, 
    gap: 25, 
    maxWidth: 900 
  },

  row: { display: 'flex', gap: 20 },

  inputGroup: { display: 'flex', flexDirection: 'column' as any, gap: 10, flex: 1 },

  // 🏷️ Texto em cima dos campos (ex: "Título do Post")
  label: { 
    color: '#aaa', // Cinza claro para leitura fácil
    fontSize: 14, 
    display: 'flex', 
    alignItems: 'center', 
    gap: 8 
  },

  // ⌨️ Caixas de texto (Inputs)
  input: { 
    padding: 15, 
    backgroundColor: '#111', // Fundo do input levemente mais claro que o card
    border: '1px solid #333', // Borda do input
    borderRadius: 12, 
    color: '#fff', // Texto que você digita fica branco
    outline: 'none', 
    fontSize: 15 
  },

  // 🚀 Botão de Publicar
  btnPublish: { 
    padding: 18, 
    backgroundColor: '#ff0000', // Vermelho de ação
    color: '#fff', 
    border: 'none', 
    borderRadius: 14, 
    fontWeight: 'bold' as any, 
    cursor: 'pointer', 
    fontSize: 16, 
    marginTop: 15,
    transition: '0.3s' // Para ficar suave ao passar o mouse
  }
};